import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const popperConfig = {
  strategy: "fixed",
  modifiers: [
    {
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        padding: 12,
      },
    },
    {
      name: "flip",
      options: {
        fallbackPlacements: ["bottom", "top", "right", "left"],
      },
    },
  ],
};

export default function HelpTooltip({ text, id, placement = "bottom" }) {
  if (!text) return null;

  const tipId = id || `help-tip-${text.slice(0, 12).replace(/\s/g, "-")}`;

  return (
    <OverlayTrigger
      placement={placement}
      popperConfig={popperConfig}
      overlay={
        <Tooltip id={tipId} className="cms-help-tooltip">
          {text}
        </Tooltip>
      }
    >
      <span
        className="ms-1 text-primary opacity-75 d-inline-flex align-items-center"
        role="button"
        tabIndex={0}
        aria-label="Help"
        style={{ cursor: "help", verticalAlign: "middle" }}
      >
        <i className="ri-question-line" />
      </span>
    </OverlayTrigger>
  );
}
